import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { StuckTreadsCheckerSettingsFormComponent } from '../stuck-treads-checker-settings-form/stuck-treads-checker-settings-form.component';
import { ISchedulerSettings } from '../../interfaces/scheduler-settings.interface';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ThreadsSchedulerSettingsComponent } from '../threads-scheduler-settings/threads-scheduler-settings.component';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-stuck-treads-checker-settings',
    templateUrl: './stuck-treads-checker-settings.component.html',
    styleUrls: ['./stuck-treads-checker-settings.component.scss']
})
export class StuckTreadsCheckerSettingsComponent implements OnInit {
    @ViewChild(StuckTreadsCheckerSettingsFormComponent)
    formComponent: StuckTreadsCheckerSettingsFormComponent;

    @Input()
    settings: ISchedulerSettings;

    get formGroup(): FormGroup {
        return _.get(this, 'formComponent.formGroup');
    }

    get isFormInvalid(): boolean {
        return _.get(this.formGroup, 'invalid', false);
    }

    get formValue(): any {
        return _.get(this.formGroup, 'value');
    }

    constructor(private dialogRef: MatDialogRef<ThreadsSchedulerSettingsComponent>) {}

    ngOnInit(): void {}

    save() {
        this.settings.initWithJSON(
            _.pick(this.formGroup.value, [
                'maxProcessThreadTTLMin',
                'processTreadsTTLResolutionSec',
                'isProcessThreadsTTLCheckerActive'
            ]) as any
        );
        this.dialogRef.close(this.settings);
    }
}
